@if (catalogRecord$ | async; as catalogRecord) {
  @if (!loading) {
    @if (catalogRecord.marcDetails) {
      <ng-container *ngTemplateOutlet="itemDetails; context: { catalogRecord: catalogRecord}"/>
    } @else {
      <div class="empty-list center-center">
        The requested catalog item could not be loaded at this time.
      </div>
    }
  } @else {
    <div class="flex-container">
      <mat-spinner/>
    </div>
  }
} @else {
  <div class="flex-container">
    <mat-spinner/>
  </div>
}

<ng-template #itemDetails let-cr="catalogRecord">
  <rn-background-accent setHeightFromSelector=".circulation"/>
  <div class="catalog-item-details-container">
    <div class="above-tabs flex-row-wrap flex-start-space-around">
      <div class="left-column">
        <rn-image-container [catalogRecord]="cr" alt="Book Cover" maxHeight="image-extra-large"/>
      </div>
      <div class="right-column flex-col">
        <div class="title-row center-xs">
          <h2 class="title">{{ (cr.title ? cr.title : 'Not Available') }}</h2>
          @if (!mobile) {
            <div class="item-status">
              @if (hold) {
                <rn-hold-status [hold]="hold"/>
              }
            </div>
          }
        </div>
        <div class="center-xs" style="margin-bottom: 12px;">
          <div>
            <div class="author">Author: {{ cr.marcDetails.author ? cr.marcDetails.author : 'Not Available' }}</div>
            <div class="published">Published:
              {{ (cr.marcDetails && cr.marcDetails.publicationDate) ? (cr.marcDetails.publicationDate) : 'Not available' }}
            </div>
            <div class="format">Format: {{ cr.materialType.description }}</div>
          </div>
        </div>
        @if (mobile) {
          @if (hold) {
            <rn-hold-status [hold]="hold" class="center-xs"/>
          }
        }
        <div class="circulation center-xs">
          <ng-container *ngTemplateOutlet="circulationInfo; context: { item: cr }"/>
        </div>
        <div class="actions">
          <div class="rating-and-favorite flex-row-wrap" style="gap: min(1.5vw, 45px)">
            <ng-container *ngTemplateOutlet="starRating"/>
            <ng-container *ngTemplateOutlet="addToFavorites"/>
            <a class="share-trigger pointer" [matMenuTriggerFor]="shareMenu">
              <mat-icon>share</mat-icon>
              <span>&nbsp;Share</span>
            </a>
            <mat-menu #shareMenu>
              <div style="padding: 8px 16px">
                <button mat-button mat-raised-button color="primary" (click)="copyLink()" style="margin: 0; height: 40px">Copy link</button>
              </div>

            </mat-menu>
          </div>
          <rn-account-status-warning context="placeHold"/>
          <div class="flex-row flex-gap-16" style="width: 100%">
            @if (!hold) {
              @if (!hasExternalAvailabilityLink(cr)) {
                <button (click)="placeHold(cr)" [disabled]="(patronStatusSelectors.hasBlocks | select) || !(patronSelectors.hasPatron | select)" color="primary"
                        mat-flat-button>
                  Place a Hold
                </button>
              }
              @if (hasExternalAvailabilityLink(cr)) {
                <a color="primary" mat-flat-button [href]="getExternalAvailabilityLink(cr)" target="_blank" rel="noopener">
                  See Availability
                </a>
              }
            }
            @if (isInTransitStatus(hold)) {
              <div class="flex-col" style="width: 100%">
                <div class="not-available flex-row">
                  <em class="ri-error-warning-fill" aria-hidden="false"></em>
                  <span>Item is "In Transit" and cannot be canceled</span>
                </div>
                <button disabled mat-flat-button>
                  Cancel Hold
                </button>
              </div>
            }
            @if (isReadyForPickupStatus(hold)) {
              <button disabled class="secondary"
                      style="cursor: default;">
                <div matTooltip="Cannot Pause or Cancel" matTooltipPosition="above">
                  Pick up by {{ hold.pickupExpireDate | date: 'MMM d' }}
                </div>
              </button>
            }
            @if (isCancellableStatus(hold)) {
              <button (click)="cancelHold()" class="secondary">
                Cancel Hold
              </button>
            }
            @if (isRequestedStatus(hold)) {
              <button (click)="pauseHold()" class="secondary">
                Pause Hold
              </button>
            }
            @if (isPausedStatus(hold)) {
              <button (click)="unpauseHold()" class="secondary">
                Unpause Hold
              </button>
            }
          </div>
          @if (!(patronSelectors.hasPatron | select)) {
            <div class="center-center">
              <span>To place a hold, please
                <a class="pointer" (click)="patronService.openLoginDialog()">
                  login to your account.
                </a>
                Don’t have an account?
                <a class="pointer" (click)="onClickRegisterHere()">
                  Register here.
                </a>
              </span>
            </div>
          }
        </div>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="tabGroup; context: {cr: cr}"/>
    <div class="related-titles-carousel">
      @if (relatedTitles$ | async; as relatedTitles) {
        <rn-book-carousel [catalogRecords]="relatedTitles" title="Related Titles"/>
      }
    </div>
  </div>
</ng-template>

<ng-template #tabGroup let-cr="cr">
  <div class="tabs">
    <mat-tab-group mat-align-tabs="start">
      <mat-tab>
        <ng-template mat-tab-label>
          <h3>Summary</h3>
        </ng-template>
        @if (meta$ | async; as metadata) {
          <rn-catalog-details-summary-tab [catalogRecord]="cr" [metadata]="metadata"/>
        }
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <h3>Availability</h3>
        </ng-template>
        <ng-template matTabContent>
          <rn-catalog-details-availability-tab [catalogRecord]="cr"/>
        </ng-template>
      </mat-tab>
      <!--        <mat-tab>-->
      <!--          <ng-template mat-tab-label>-->
      <!--            <h3>Reviews</h3>-->
      <!--          </ng-template>-->
      <!--          <ng-template matTabContent>-->
      <!--            <rn-catalog-details-reviews-tab [catalogRecord]="cr"/>-->
      <!--          </ng-template>-->
      <!--        </mat-tab>-->
      @if (organizationSelectors.hasNovelistConfig | select) {
        <mat-tab>
          <ng-template mat-tab-label>
            <h3>Related Content</h3>
          </ng-template>
          <ng-template matTabContent>
            <rn-catalog-details-novelist-tab [catalogRecord]="cr"
                                             [novelistProfile]="organizationSelectors.novelistProfile | select"
                                             [novelistPassword]="organizationSelectors.novelistPassword | select"/>
          </ng-template>
        </mat-tab>
      }
    </mat-tab-group>
  </div>
</ng-template>

<ng-template #circulationInfo let-item="item">
  <rn-availability-count-pill [available]="item.availability.availableCount"
                              [holds]="item.availability.holdsInQueue"/>
</ng-template>

<ng-template #starRating>
  @if (chiliFreshRating$ | async; as rating) {
    <span class="rating" matTooltip="Ratings provided by ChiliFresh">
      <span [class.rating-stars]="rating.ratingCount > 0">
        @for (i of [1, 2, 3, 4, 5]; track i) {
          @if (i <= rating.averageRating) {
            <mat-icon>star</mat-icon>
          }
          @if (i > rating.averageRating && i - 1 < rating.averageRating) {
            <mat-icon>star_half</mat-icon>
          }
          @if (i - 1 >= rating.averageRating) {
            <mat-icon>star_border</mat-icon>
          }
        }
      </span>
      <span>&nbsp;{{ rating.ratingCount }} Ratings</span>
    </span>
  }
</ng-template>

<ng-template #addToFavorites>
  @if (favoriteService?.favorites | async; as favorites) {
    <span class="favorite">
      @if (!favorites[catalogRecordId]) {
        <span (click)="addFavorite()" class="pointer">
          <mat-icon class="add-to-favorite-heart">favorite_border</mat-icon>
          <span>&nbsp;Add to Favorites</span>
        </span>
      }
      @if (!!favorites[catalogRecordId]) {
        <span (click)="deleteFavorite()" class="pointer">
          <mat-icon class="favorite-heart">favorite</mat-icon>
          <span>&nbsp;Favorite</span>
        </span>
      }
    </span>
  }
</ng-template>
